import React from "react";
import "./TaskNumberList.css";
function TaskNumberList({ data }) {
  return (
    <div>
    {data && <div className="container">
        <div className="row">
          <div className="col-md-3 mb-3">
            <div className="newtask1">
              <h4>{data.taskCounts.newTask}</h4>
              <h3>New Task</h3>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="newtask2">
              <h4>{data.taskCounts.active}</h4>
              <h3>Accepted Task</h3>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="newtask3">
              <h4>{data.taskCounts.completed}</h4>
              <h3>Completed Task</h3>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="newtask4">
              <h4>{data.taskCounts.failed}</h4>
              <h3>Failed Task</h3>
            </div>
          </div>
        </div>
      </div>}
      
    </div>
  );
}

export default TaskNumberList;
